import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TrendingTitlesService } from './../../services/trending-titles/trending-titles.service';
import { TrendingTitles, TrendingTitlesFilter } from '../../models';
import { MatRadioChange, MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LoadingSpinnerComponent } from '../../../../shared/components/loading-spinner/loading-spinner.component';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';

@Component({
  selector: 'insight-trending-titles',
  templateUrl: './trending-titles.component.html',
  styleUrls: ['./trending-titles.component.scss', '../../scss/operational-dashboard-shared.scss'],
  imports: [RouterLink, MatRadioGroup, FormsModule, MatRadioButton, LoadingSpinnerComponent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class TrendingTitlesComponent implements OnInit, OnDestroy {
  public isLoading = true;
  public didError = false;
  public tableDataSource: TrendingTitles[];
  public selectedTimeRangeRadioButton: TrendingTitlesFilter;

  public trendingTitlesFilters: TrendingTitlesFilter[] = [];

  public displayedColumns = [
    'title',
    'mediaType',
    'orderCount'
  ];

  private $unsubscribeSubject = new Subject();

  constructor(private trendingTitlesService: TrendingTitlesService, private toastr: ToastrService) { }

  ngOnInit() {
    this.trendingTitlesFilters = [
      new TrendingTitlesFilter('Next Week', 7),
      new TrendingTitlesFilter('Next Two Weeks', 14),
      new TrendingTitlesFilter('Next Month', 30)
    ];
    this.selectedTimeRangeRadioButton = this.trendingTitlesFilters[0];


    this.trendingTitlesService.getTrendingTitles(this.selectedTimeRangeRadioButton.daysOut)
      .pipe(takeUntil(this.$unsubscribeSubject))
      .subscribe((updatedTitles: TrendingTitles[]) => {
        this.isLoading = false;
        this.tableDataSource = updatedTitles;
      }, (error: any) => {
        this.isLoading = false;
        this.didError = true;
        this.toastr.error('Failed to retrieve trending titles', 'Error');
      });
  }

  ngOnDestroy() {
    this.$unsubscribeSubject.next();
    this.$unsubscribeSubject.complete();
  }

  public selectedTimeChanged(event: MatRadioChange) {
    this.isLoading = true;
    this.trendingTitlesService.getTrendingTitlesOnce(this.selectedTimeRangeRadioButton.daysOut).then(titles => {
      this.isLoading = false;
      this.tableDataSource = titles;
    });
  }
}
